import { NgModule } from '@angular/core';
import { AppConfigComponent } from 'src/app/app.config.component';
import { AppFooterComponent } from 'src/app/app.footer.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMenuComponent } from 'src/app/app.menu.component';
import { AppMenuitemComponent } from 'src/app/app.menuitem.component';
import { AppRightmenuComponent } from 'src/app/app.rightmenu.component';
import { AppSearchComponent } from 'src/app/app.search.component';
import { AppTopBarComponent } from 'src/app/app.topbar.component';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SharedModule } from 'src/app/shared/shared/shared.module';
import { FocuspayModule } from '../focuspay/focuspay.module';
import { CommandCenterSetupComponent } from './admin-section/command-center-setup/command-center-setup.component';
import { MenuSetupComponent } from './admin-section/command-center-setup/menu-setup/menu-setup.component';
import { ReportSetupComponent } from './admin-section/command-center-setup/report-setup/report-setup.component';
import { TableDataModelListComponent } from './admin-section/command-center-setup/table-data-model-list/table-data-model-list.component';
import { TableDataModelSetupComponent } from './admin-section/command-center-setup/table-data-model-setup/table-data-model-setup.component';
import { DealerAdminDashboardComponent } from './admin-section/dealers/dealer-admin-dashboard/dealer-admin-dashboard.component';
import { DealerListComponent } from './admin-section/dealers/dealer-admin-dashboard/dealer-list/dealer-list.component';
import { DealerSetupComponent } from './admin-section/dealers/dealer-admin-dashboard/dealer-setup/dealer-setup.component';
import { SocketMessageComponent } from './admin-section/socket-monitor/socket-message/socket-message.component';
import { SocketMonitorComponent } from './admin-section/socket-monitor/socket-monitor.component';
import { AppLoginComponent } from './app.login.component';
import { CheckPaymentEditComponent } from './check-record-viewer/check-payment-edit/check-payment-edit.component';
import { CheckRecordViewerComponent } from './check-record-viewer/check-record-viewer.component';
import { CommandCenterRoutingModule } from './command-center-routing.module';
import { AutomaticEmployeeMessageListComponent } from './communication/automatic-employee-messages/automatic-employee-message-list/automatic-employee-message-list.component';
import { AutomaticEmployeeMessageSingleHistoryComponent } from './communication/automatic-employee-messages/automatic-employee-message-single/automatic-employee-message-single-history/automatic-employee-message-single-history.component';
import { AutomaticEmployeeMessageSingleComponent } from './communication/automatic-employee-messages/automatic-employee-message-single/automatic-employee-message-single.component';
import { AutomaticEmployeeMessagesComponent } from './communication/automatic-employee-messages/automatic-employee-messages.component';
import { EmployeeMessageNewRecordComponent } from './communication/employee-message/employee-message-new-record/employee-message-new-record.component';
import { EmployeeMessageComponent } from './communication/employee-message/employee-message.component';
import { LogListViewComponent } from './communication/manager-log/log-list-view/log-list-view.component';
import { LogCommentCreateComponent } from './communication/manager-log/log-list-view/log-viewer/log-comment-create/log-comment-create.component';
import { LogCommentComponent } from './communication/manager-log/log-list-view/log-viewer/log-comment/log-comment.component';
import { LogViewSalesSummaryComponent } from './communication/manager-log/log-list-view/log-viewer/log-view-sales-summary/log-view-sales-summary.component';
import { LogViewerComponent } from './communication/manager-log/log-list-view/log-viewer/log-viewer.component';
import { ContractDashboardComponent } from './contract-finance/contract-dashboard/contract-dashboard.component';
import { ContractListComponent } from './contract-finance/contract-dashboard/contract-list/contract-list.component';
import { ContractRecordComponent } from './contract-finance/contract-dashboard/contract-record/contract-record.component';
import { ContractFinancePaymentProfileListComponent } from './contract-finance/contract-finance-payment-profile-list/contract-finance-payment-profile-list.component';
import { ContractFinanceSetupComponent } from './contract-finance/contract-finance-setup/contract-finance-setup.component';
import { ContractFinanceVenueCustomerListComponent } from './contract-finance/contract-finance-setup/contract-finance-venue-customer-list/contract-finance-venue-customer-list.component';
import { ContractFinanceComponent } from './contract-finance/contract-finance.component';
import { InvoiceDashboardComponent } from './contract-finance/invoice-dashboard/invoice-dashboard.component';
import { InvoiceListComponent } from './contract-finance/invoice-dashboard/invoice-list/invoice-list.component';
import { InvoiceRecordLinesComponent } from './contract-finance/invoice-dashboard/invoice-record/invoice-record-lines/invoice-record-lines.component';
import { InvoiceRecordComponent } from './contract-finance/invoice-dashboard/invoice-record/invoice-record.component';
import { ServiceSubscriptionDashboardComponent } from './contract-finance/service-subscription-dashboard/service-subscription-dashboard.component';
import { ServiceSubscriptionListComponent } from './contract-finance/service-subscription-dashboard/service-subscription-list/service-subscription-list.component';
import { ServiceSubscriptionRecordComponent } from './contract-finance/service-subscription-dashboard/service-subscription-record/service-subscription-record.component';
import { BatchListComponent } from './credit/credit-dashboard/batch-list/batch-list.component';
import { BatchRecordDetailComponent } from './credit/credit-dashboard/batch-record/batch-record-detail/batch-record-detail.component';
import { BatchRecordComponent } from './credit/credit-dashboard/batch-record/batch-record.component';
import { CreditDashboardChartComponent } from './credit/credit-dashboard/credit-dashboard-chart/credit-dashboard-chart.component';
import { CreditDashboardHeaderComponent } from './credit/credit-dashboard/credit-dashboard-header/credit-dashboard-header.component';
import { CreditDashboardComponent } from './credit/credit-dashboard/credit-dashboard.component';
import { CreditNotFocuspayComponent } from './credit/credit-dashboard/credit-not-focuspay/credit-not-focuspay.component';
import { ProcessingStatusComponent } from './credit/processing-status/processing-status.component';
import { RegisterDealComponent } from './crm/register-deal/register-deal.component';
import { CustomerDashboardComponent } from './customer/customer-dashboard/customer-dashboard.component';
import { CustomerSummaryComponent } from './customer/customer-dashboard/customer-summary/customer-summary.component';
import { CustomerBioDetailComponent } from './customer/customer-detail/customer-bio-detail/customer-bio-detail.component';
import { CustomerDetailComponent } from './customer/customer-detail/customer-detail.component';
import { CustomerFocusKeySetupComponent } from './customer/customer-detail/customer-focus-key-setup/customer-focus-key-setup.component';
import { CustomerLoyaltyDetailComponent } from './customer/customer-detail/customer-loyalty-detail/customer-loyalty-detail.component';
import { CustomerNoteDetailComponent } from './customer/customer-detail/customer-note-detail/customer-note-detail.component';
import { CustomerSubscriptionItemsComponent } from './customer/customer-detail/customer-subscription-items/customer-subscription-items.component';
import { CustomerSubscriptionRecordHistoryComponent } from './customer/customer-detail/customer-subscription-items/customer-subscription-record-history/customer-subscription-record-history.component';
import { CustomerSubscriptionRecordComponent } from './customer/customer-detail/customer-subscription-items/customer-subscription-record/customer-subscription-record.component';
import { CustomerVisitDetailComponent } from './customer/customer-detail/customer-visit-detail/customer-visit-detail.component';
import { CustomerStatisticDashboardComponent } from './customer/customer-statistic-dashboard/customer-statistic-dashboard.component';
import { CustomerSurveyDashboardComponent } from './customer/customer-survey/customer-survey-dashboard/customer-survey-dashboard.component';
import { CustomerSurveyListComponent } from './customer/customer-survey/customer-survey-list/customer-survey-list.component';
import { CustomerSurveyPreviewComponent } from './customer/customer-survey/customer-survey-preview/customer-survey-preview.component';
import { CustomerSurveyResponseListComponent } from './customer/customer-survey/customer-survey-response-list/customer-survey-response-list.component';
import { CustomerSurveyResultComponent } from './customer/customer-survey/customer-survey-result/customer-survey-result.component';
import { CustomerSurveySetupComponent } from './customer/customer-survey/customer-survey-setup/customer-survey-setup.component';
import { CustomerSurveyComponent } from './customer/customer-survey/customer-survey.component';
import { DashboardLoadingComponent } from './dashboard-v2/dashboard-loading/dashboard-loading.component';
import { DashboardV2Component } from './dashboard-v2/dashboard-v2.component';
import { ItemDashComponent } from './dashboard-v2/item-dash/item-dash.component';
import { ItemPerformanceViewComponent } from './dashboard-v2/item-dash/item-performance-view/item-performance-view.component';
import { LaborDashComponent } from './dashboard-v2/labor-dash/labor-dash.component';
import { OnlineDashComponent } from './dashboard-v2/online-dash/online-dash.component';
import { OrderTypeMealPeriodWidgetComponent } from './dashboard-v2/sales-dash/order-type-meal-period-widget/order-type-meal-period-widget.component';
import { SalesDashComponent } from './dashboard-v2/sales-dash/sales-dash.component';
import { SalesGuestWidgetComponent } from './dashboard-v2/sales-dash/sales-guest-widget/sales-guest-widget.component';
import { ChecksDashboardComponent } from './dashboard/checks-dashboard/checks-dashboard.component';
import { CustomerDashboardWidgetComponent } from './dashboard/customer-dashboard/customer-dashboard.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { KitchenPerformanceDashboardComponent } from './dashboard/kitchen-performance-dashboard/kitchen-performance-dashboard.component';
import { ProductUseDashboardComponent } from './dashboard/product-use-dashboard/product-use-dashboard.component';
import { SystemStatusDashboardComponent } from './dashboard/system-status-dashboard/system-status-dashboard.component';
import { DealerDashboardComponent } from './dealers/dealer-dashboard/dealer-dashboard.component';
import { DealerVenueListViewComponent } from './dealers/dealer-venue-list-view/dealer-venue-list-view.component';
import { DealerVenueInformationComponent } from './dealers/dealer-venue-tools/dealer-venue-information/dealer-venue-information.component';
import { DealerVenueStatusComponent } from './dealers/dealer-venue-tools/dealer-venue-information/dealer-venue-status/dealer-venue-status.component';
import { DealerVenueToolOptionsComponent } from './dealers/dealer-venue-tools/dealer-venue-tool-options/dealer-venue-tool-options.component';
import { DealerVenueToolsComponent } from './dealers/dealer-venue-tools/dealer-venue-tools.component';
import { DealersComponent } from './dealers/dealers.component';
import { EmployeeLaborShiftListComponent } from './employee-management/employee-scheduling/employee-labor-shift/employee-labor-shift-list/employee-labor-shift-list.component';
import { EmployeeLaborShiftComponent } from './employee-management/employee-scheduling/employee-labor-shift/employee-labor-shift.component';
import { EmployeeScheduleListComponent } from './employee-management/employee-scheduling/employee-schedule-list/employee-schedule-list.component';
import { EmployeeScheduleEventComponent } from './employee-management/employee-scheduling/employee-schedule-record/employee-schedule-event/employee-schedule-event.component';
import { EmployeeScheduleRecordComponent } from './employee-management/employee-scheduling/employee-schedule-record/employee-schedule-record.component';
import { EmployeeScheduleTimeComponent } from './employee-management/employee-scheduling/employee-schedule-record/employee-schedule-time/employee-schedule-time.component';
import { EmployeeSchedulingComponent } from './employee-management/employee-scheduling/employee-scheduling.component';
import { EmployeeListComponent } from './employee-management/employees/employee-list/employee-list.component';
import { EmployeeRecordComponent } from './employee-management/employees/employee-record/employee-record.component';
import { EmployeesComponent } from './employee-management/employees/employees.component';
import { TimeAndAttendanceComponent } from './employee-management/time-and-attendance/time-and-attendance.component';
import { TimecardListComponent } from './employee-management/time-and-attendance/timecard-list/timecard-list.component';
import { TimecardRecordComponent } from './employee-management/time-and-attendance/timecard-record/timecard-record.component';
import { GuestViewComponent } from './guest/guest-view/guest-view.component';
import { LoginComponent } from './login/login.component';
import { LoyaltyEmailTemplateSetupComponent } from './loyalty/loyalty-email-template-setup/loyalty-email-template-setup.component';
import { LoyaltyComponent } from './loyalty/loyalty.component';
import { BlastCreateNewComponent } from './marketing/blasts/blast-create-new/blast-create-new.component';
import { BlastDetailComponent } from './marketing/blasts/blast-detail/blast-detail.component';
import { BlastsComponent } from './marketing/blasts/blasts.component';
import { GroupSetupComponent } from './marketing/groups/group-setup/group-setup.component';
import { GroupsComponent } from './marketing/groups/groups.component';
import { TemplateSetupComponent } from './marketing/templates/template-setup/template-setup.component';
import { TemplatesComponent } from './marketing/templates/templates.component';
import { CanvasNewPromptComponent } from './menu/canvas-setup/canvas-new-prompt/canvas-new-prompt.component';
import { CanvasDetailComponent } from './menu/canvas-setup/canvas-record-setup/canvas-detail/canvas-detail.component';
import { CanvasItemIncludedListComponent } from './menu/canvas-setup/canvas-record-setup/canvas-item-included-list/canvas-item-included-list.component';
import { CanvasItemListComponent } from './menu/canvas-setup/canvas-record-setup/canvas-item-list/canvas-item-list.component';
import { CanvasMenuItemCreateComponent } from './menu/canvas-setup/canvas-record-setup/canvas-menu-item-create/canvas-menu-item-create.component';
import { CanvasRecordSetupComponent } from './menu/canvas-setup/canvas-record-setup/canvas-record-setup.component';
import { CanvasSubscriptionItemsListComponent } from './menu/canvas-setup/canvas-record-setup/canvas-subscription-setup/canvas-subscription-items-list/canvas-subscription-items-list.component';
import { CanvasSubscriptionSetupComponent } from './menu/canvas-setup/canvas-record-setup/canvas-subscription-setup/canvas-subscription-setup.component';
import { CanvasSetupComponent } from './menu/canvas-setup/canvas-setup.component';
import { CanvasListComponent } from './menu/canvases/canvas-list/canvas-list.component';
import { CanvasItemsComponent } from './menu/canvases/canvas/canvas-items/canvas-items.component';
import { CanvasKioskSettingsComponent } from './menu/canvases/canvas/canvas-kiosk-settings/canvas-kiosk-settings.component';
import { CanvasNewComponent } from './menu/canvases/canvas/canvas-new/canvas-new.component';
import { CanvasSettingsComponent } from './menu/canvases/canvas/canvas-settings/canvas-settings.component';
import { CanvasSubscriptionItemsComponent } from './menu/canvases/canvas/canvas-subscription-items/canvas-subscription-items.component';
import { CanvasSubscriptionSettingsComponent } from './menu/canvases/canvas/canvas-subscription-settings/canvas-subscription-settings.component';
import { CanvasComponent } from './menu/canvases/canvas/canvas.component';
import { CanvasesComponent } from './menu/canvases/canvases.component';
import { CustomMenuRecordComponent } from './menu/custom-menu-setup/custom-menu-record/custom-menu-record.component';
import { OoMenuExternalLinkComponent } from './menu/custom-menu-setup/custom-menu-record/oo-menu-external-link/oo-menu-external-link.component';
import { CustomMenuSetupComponent } from './menu/custom-menu-setup/custom-menu-setup.component';
import { MenuItemCanvasViewComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-canvas-view/menu-item-canvas-view.component';
import { MenuItemDetailComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-detail/menu-item-detail.component';
import { MenuItemModifierViewComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-modifier-view/menu-item-modifier-view.component';
import { MenuItemNutritionalInformationComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-nutritional-information/menu-item-nutritional-information.component';
import { MenuItemPriceRecordComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-price-record/menu-item-price-record.component';
import { MenuItemRecordSetupComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-record-setup.component';
import { MenuItemSubscriptionHistoryComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-subscription-setup/menu-item-subscription-history/menu-item-subscription-history.component';
import { MenuItemSubscriptionSetupComponent } from './menu/menu-item-setup/menu-item-record-setup/menu-item-subscription-setup/menu-item-subscription-setup.component';
import { MenuItemSetupComponent } from './menu/menu-item-setup/menu-item-setup.component';
import { PriceLevelSetupComponent } from './menu/price-level-setup/price-level-setup.component';
import { ApplicationListViewComponent } from './payments/application-status/application-list-view/application-list-view.component';
import { ApplicationSingleViewComponent } from './payments/application-status/application-single-view/application-single-view.component';
import { ApplicationStatusSingleComponent } from './payments/application-status/application-status-single/application-status-single.component';
import { ApplicationStatusComponent } from './payments/application-status/application-status.component';
import { DeviceManagementComponent } from './payments/devices/device-management/device-management.component';
import { DevicesComponent } from './payments/devices/devices.component';
import { ProductBubbleChartComponent } from './product-section/product-dashboard/product-bubble-chart/product-bubble-chart.component';
import { ProductDashboardComponent } from './product-section/product-dashboard/product-dashboard.component';
import { ProductSectionComponent } from './product-section/product-section.component';
import { EGiftTransactionRecordComponent } from './reports/e-gift-transactions/e-gift-transaction-record/e-gift-transaction-record.component';
import { EGiftTransactionsComponent } from './reports/e-gift-transactions/e-gift-transactions.component';
import { DailySalesReportChartHeaderComponent } from './reports/reports/daily-sales-report/daily-sales-report-chart-header/daily-sales-report-chart-header.component';
import { DailySalesReportContentComponent } from './reports/reports/daily-sales-report/daily-sales-report-content/daily-sales-report-content.component';
import { DailySalesReportComponent } from './reports/reports/daily-sales-report/daily-sales-report.component';
import { InternetHistoryReportComponent } from './reports/reports/internet-history-report/internet-history-report.component';
import { ProductUseReportComponent } from './reports/reports/product-use-report/product-use-report.component';
import { ReportFutureOrderItemComponent } from './reports/reports/report-future-order-item/report-future-order-item.component';
import { ReportsCategoriesComponent } from './reports/reports/reports-categories/reports-categories.component';
import { ReportsHeaderComponent } from './reports/reports/reports-header/reports-header.component';
import { ReportsComponent } from './reports/reports/reports.component';
import { TablePerformanceReportComponent } from './reports/reports/table-performance-report/table-performance-report.component';
import { TipPoolReportComponent } from './reports/reports/tip-pool-report/tip-pool-report.component';
import { TipPoolSetupComponent } from './reports/reports/tip-pool-report/tip-pool-setup/tip-pool-setup.component';
import { AliasUrlSetupComponent } from './setup/alias-url-setup/alias-url-setup.component';
import { GeneralDisplaySetupComponent } from './setup/general-setup/general-display-setup/general-display-setup.component';
import { GeneralMessagingSetupComponent } from './setup/general-setup/general-messaging-setup/general-messaging-setup.component';
import { GeneralOrderHandlingSetupComponent } from './setup/general-setup/general-order-handling-setup/general-order-handling-setup.component';
import { GeneralPosSetupComponent } from './setup/general-setup/general-pos-setup/general-pos-setup.component';
import { GeneralSetupComponent } from './setup/general-setup/general-setup.component';
import { GeneralStoreSetupComponent } from './setup/general-setup/general-store-setup/general-store-setup.component';
import { EGiftCardDenominationSetupComponent } from './setup/gift-card-setup/e-gift-card-denomination-setup/e-gift-card-denomination-setup.component';
import { EGiftCardPoolSetupComponent } from './setup/gift-card-setup/e-gift-card-pool-setup/e-gift-card-pool-setup.component';
import { EGiftEmailSetupComponent } from './setup/gift-card-setup/e-gift-email-setup/e-gift-email-setup.component';
import { EGiftPromoCodeSetupComponent } from './setup/gift-card-setup/e-gift-promo-code-setup/e-gift-promo-code-setup.component';
import { EGiftSetupComponent } from './setup/gift-card-setup/e-gift-setup/e-gift-setup.component';
import { GiftCardAppleWalletSetupComponent } from './setup/gift-card-setup/gift-card-apple-wallet-setup/gift-card-apple-wallet-setup.component';
import { GiftCardSetupComponent } from './setup/gift-card-setup/gift-card-setup.component';
import { GiftCardTransactionsComponent } from './setup/gift-card-setup/gift-card-transactions/gift-card-transactions.component';
import { GiftCardDashboardComponent } from './setup/gift-card-setup/gift-card-view/gift-card-dashboard/gift-card-dashboard.component';
import { GiftCardListComponent } from './setup/gift-card-setup/gift-card-view/gift-card-list/gift-card-list.component';
import { GiftCardRecordComponent } from './setup/gift-card-setup/gift-card-view/gift-card-list/gift-card-record/gift-card-record.component';
import { GiftCardBalanceSheetComponent } from './setup/gift-card-setup/gift-card-view/gift-card-reports/gift-card-balance-sheet/gift-card-balance-sheet.component';
import { GiftCardReportsComponent } from './setup/gift-card-setup/gift-card-view/gift-card-reports/gift-card-reports.component';
import { GiftCardViewComponent } from './setup/gift-card-setup/gift-card-view/gift-card-view.component';
import { IntegrationDoordashSetupComponent } from './setup/integration-setup/integration-doordash-setup/integration-doordash-setup.component';
import { IntegrationExternalIntegrationSetupComponent } from './setup/integration-setup/integration-external-integration-setup/integration-external-integration-setup.component';
import { IntegrationSetupComponent } from './setup/integration-setup/integration-setup.component';
import { IntegrationThirdPartyIntegrationSetupComponent } from './setup/integration-setup/integration-third-party-integration-setup/integration-third-party-integration-setup.component';
import { IntegrationUbereatsRequestListComponent } from './setup/integration-setup/integration-ubereats-setup/integration-ubereats-request-list/integration-ubereats-request-list.component';
import { IntegrationUbereatsSetupComponent } from './setup/integration-setup/integration-ubereats-setup/integration-ubereats-setup.component';
import { ItemTagSetupComponent } from './setup/item-tag-setup/item-tag-setup.component';
import { LinkKeySetupComponent } from './setup/link-key-setup/link-key-setup.component';
import { LinkQrExportComponent } from './setup/link-key-setup/link-qr-export/link-qr-export.component';
import { ConnectorSetupComponent } from './setup/link/connector-setup/connector-setup.component';
import { DataImportHistoryComponent } from './setup/link/data-import-history/data-import-history.component';
import { KitchenDeviceListComponent } from './setup/link/kitchen-setup/kitchen-device-list/kitchen-device-list.component';
import { KitchenDeviceColorProfileSetupComponent } from './setup/link/kitchen-setup/kitchen-device-setup/kitchen-device-color-profile-setup/kitchen-device-color-profile-setup.component';
import { KitchenDeviceFeatureSetupComponent } from './setup/link/kitchen-setup/kitchen-device-setup/kitchen-device-feature-setup/kitchen-device-feature-setup.component';
import { KitchenDeviceSetupComponent } from './setup/link/kitchen-setup/kitchen-device-setup/kitchen-device-setup.component';
import { KitchenOrderReadySmsMessageComponent } from './setup/link/kitchen-setup/kitchen-order-ready-sms-message/kitchen-order-ready-sms-message.component';
import { KitchenOrderTypeSetupComponent } from './setup/link/kitchen-setup/kitchen-order-type-setup/kitchen-order-type-setup.component';
import { KitchenPrintOrderRecordComponent } from './setup/link/kitchen-setup/kitchen-print-orders/kitchen-print-order-record/kitchen-print-order-record.component';
import { KitchenPrintOrdersComponent } from './setup/link/kitchen-setup/kitchen-print-orders/kitchen-print-orders.component';
import { KitchenSetupComponent } from './setup/link/kitchen-setup/kitchen-setup.component';
import { PrinterDeviceListComponent } from './setup/link/kitchen-setup/printer-device-list/printer-device-list.component';
import { PrinterDeviceSetupComponent } from './setup/link/kitchen-setup/printer-device-setup/printer-device-setup.component';
import { OnDeviceListComponent } from './setup/link/on-setup/on-device-list/on-device-list.component';
import { OnDeviceFeaturesComponent } from './setup/link/on-setup/on-device-setup/on-device-features/on-device-features.component';
import { OnDevicePaymentComponent } from './setup/link/on-setup/on-device-setup/on-device-payment/on-device-payment.component';
import { OnDeviceSettingsComponent } from './setup/link/on-setup/on-device-setup/on-device-settings/on-device-settings.component';
import { OnDeviceSetupComponent } from './setup/link/on-setup/on-device-setup/on-device-setup.component';
import { OnLicenseModesComponent } from './setup/link/on-setup/on-device-setup/on-license-modes/on-license-modes.component';
import { OnSetupComponent } from './setup/link/on-setup/on-setup.component';
import { MobilePaySetupComponent } from './setup/mobile-pay-setup/mobile-pay-setup.component';
import { OrderTypeAtTableSettingsComponent } from './setup/order-type-setup/order-type-record-setup/order-type-at-table-settings/order-type-at-table-settings.component';
import { OrderTypeCustomFieldsComponent } from './setup/order-type-setup/order-type-record-setup/order-type-custom-fields/order-type-custom-fields.component';
import { OrderTypeKioskSetupComponent } from './setup/order-type-setup/order-type-record-setup/order-type-kiosk-setup/order-type-kiosk-setup.component';
import { OrderTypeRecordSetupComponent } from './setup/order-type-setup/order-type-record-setup/order-type-record-setup.component';
import { OrderTypeSettingsComponent } from './setup/order-type-setup/order-type-record-setup/order-type-settings/order-type-settings.component';
import { OrderTypeThrottlingComponent } from './setup/order-type-setup/order-type-record-setup/order-type-throttling/order-type-throttling.component';
import { OrderTypeTipsComponent } from './setup/order-type-setup/order-type-record-setup/order-type-tips/order-type-tips.component';
import { OrderTypeZonesComponent } from './setup/order-type-setup/order-type-record-setup/order-type-zones/order-type-zones.component';
import { OrderTypeSetupComponent } from './setup/order-type-setup/order-type-setup.component';
import { PaymentLoyaltySetupComponent } from './setup/payment-loyalty-setup/payment-loyalty-setup.component';
import { PaymentProcessorFocuspayDatacapComponent } from './setup/payment-loyalty-setup/payment-processor-setup/payment-processor-focuspay-datacap/payment-processor-focuspay-datacap.component';
import { PaymentProcessorSetupComponent } from './setup/payment-loyalty-setup/payment-processor-setup/payment-processor-setup.component';
import { PromoCodeListViewComponent } from './setup/promo-code-setup/promo-code-list-view/promo-code-list-view.component';
import { PromoCodeRecordViewComponent } from './setup/promo-code-setup/promo-code-record-view/promo-code-record-view.component';
import { PromoCodeSetupComponent } from './setup/promo-code-setup/promo-code-setup.component';
import { SnapshotSetupComponent } from './setup/snapshot-setup/snapshot-setup.component';
import { StyleSetupComponent } from './setup/style-setup/style-setup.component';
import { TimeRangeSetupComponent } from './setup/time-ranges/time-range-setup/time-range-setup.component';
import { TimeRangesComponent } from './setup/time-ranges/time-ranges.component';
import { VenueAdministrationComponent } from './setup/venue-administration/venue-administration.component';
import { VenueIntegrationsComponent } from './setup/venue-administration/venue-integrations/venue-integrations.component';
import { VenueLicensesComponent } from './setup/venue-administration/venue-licenses/venue-licenses.component';
import { VenueSetupComponent } from './setup/venue-administration/venue-setup/venue-setup.component';
import { VenueGroupSetupComponent } from './setup/venue-group-setup/venue-group-setup.component';
import { WebhookRecordComponent } from './setup/webhook-setup/webhook-record/webhook-record.component';
import { WebhookSetupComponent } from './setup/webhook-setup/webhook-setup.component';
import { SubscriptionDashboardViewComponent } from './subscriptions/subscription-dashboard-view/subscription-dashboard-view.component';
import { SubscriptionListComponent } from './subscriptions/subscription-list/subscription-list.component';
import { SubscriptionRecordViewComponent } from './subscriptions/subscription-record-view/subscription-record-view.component';
import { SubscriptionSetupComponent } from './subscriptions/subscription-setup/subscription-setup.component';
import { UserClaimComponent } from './user/user-claim/user-claim.component';
import { UserDetailComponent } from './user/user-detail/user-detail.component';
import { UserMenuSetupComponent } from './user/user-detail/user-menu-setup/user-menu-setup.component';
import { UserProfileComponent } from './user/user-detail/user-profile/user-profile.component';
import { UserVenueSetupComponent } from './user/user-detail/user-venue-setup/user-venue-setup.component';
import { UserPasswordResetComponent } from './user/user-password-reset/user-password-reset.component';
import { UserSetupComponent } from './user/user-setup/user-setup.component';
import { EmployeeSchedulingSetupComponent } from './employee-management/employee-scheduling/employee-scheduling-setup/employee-scheduling-setup.component';
import { EmployeeLaborShiftRecordComponent } from './employee-management/employee-scheduling/employee-labor-shift/employee-labor-shift-record/employee-labor-shift-record.component';
import { EmployeeSchedulingSetupJobRuleComponent } from './employee-management/employee-scheduling/employee-scheduling-setup/employee-scheduling-setup-job-rule/employee-scheduling-setup-job-rule.component';
import { EmployeeSchedulingSetupGlobalRulesComponent } from './employee-management/employee-scheduling/employee-scheduling-setup/employee-scheduling-setup-global-rules/employee-scheduling-setup-global-rules.component';

@NgModule({
	declarations: [
		AliasUrlSetupComponent,
		AppConfigComponent,
		AppFooterComponent,
		ApplicationListViewComponent,
		ApplicationSingleViewComponent,
		ApplicationStatusComponent,
		ApplicationStatusSingleComponent,
		AppLoginComponent,
		AppMainComponent,
		AppMenuComponent,
		AppMenuitemComponent,
		AppRightmenuComponent,
		AppSearchComponent,
		AppTopBarComponent,
		AutomaticEmployeeMessageListComponent,
		AutomaticEmployeeMessagesComponent,
		AutomaticEmployeeMessageSingleComponent,
		AutomaticEmployeeMessageSingleHistoryComponent,
		BatchListComponent,
		BatchRecordComponent,
		BatchRecordDetailComponent,
		BlastCreateNewComponent,
		BlastDetailComponent,
		BlastsComponent,
		CanvasComponent,
		CanvasDetailComponent,
		CanvasesComponent,
		CanvasItemIncludedListComponent,
		CanvasItemListComponent,
		CanvasItemsComponent,
		CanvasKioskSettingsComponent,
		CanvasListComponent,
		CanvasMenuItemCreateComponent,
		CanvasNewComponent,
		CanvasNewPromptComponent,
		CanvasRecordSetupComponent,
		CanvasSettingsComponent,
		CanvasSetupComponent,
		CanvasSubscriptionItemsComponent,
		CanvasSubscriptionItemsListComponent,
		CanvasSubscriptionSettingsComponent,
		CanvasSubscriptionSetupComponent,
		CheckPaymentEditComponent,
		CheckRecordViewerComponent,
		ChecksDashboardComponent,
		CommandCenterSetupComponent,
		ConnectorSetupComponent,
		ContractDashboardComponent,
		ContractFinanceComponent,
		ContractFinancePaymentProfileListComponent,
		ContractFinanceSetupComponent,
		ContractFinanceVenueCustomerListComponent,
		ContractListComponent,
		ContractRecordComponent,
		CreditDashboardChartComponent,
		CreditDashboardComponent,
		CreditDashboardHeaderComponent,
		CreditNotFocuspayComponent,
		CustomerBioDetailComponent,
		CustomerDashboardComponent,
		CustomerDashboardWidgetComponent,
		CustomerDetailComponent,
		CustomerFocusKeySetupComponent,
		CustomerLoyaltyDetailComponent,
		CustomerNoteDetailComponent,
		CustomerStatisticDashboardComponent,
		CustomerSubscriptionItemsComponent,
		CustomerSubscriptionRecordComponent,
		CustomerSubscriptionRecordHistoryComponent,
		CustomerSummaryComponent,
		CustomerSurveyComponent,
		CustomerSurveyDashboardComponent,
		CustomerSurveyListComponent,
		CustomerSurveyPreviewComponent,
		CustomerSurveyResponseListComponent,
		CustomerSurveyResultComponent,
		CustomerSurveySetupComponent,
		CustomerVisitDetailComponent,
		CustomMenuRecordComponent,
		CustomMenuSetupComponent,
		DailySalesReportChartHeaderComponent,
		DailySalesReportComponent,
		DailySalesReportContentComponent,
		DashboardComponent,
		DashboardLoadingComponent,
		DashboardV2Component,
		DataImportHistoryComponent,
		DataTableComponent,
		DealerAdminDashboardComponent,
		DealerDashboardComponent,
		DealerListComponent,
		DealersComponent,
		DealerSetupComponent,
		DealerVenueInformationComponent,
		DealerVenueListViewComponent,
		DealerVenueStatusComponent,
		DealerVenueToolOptionsComponent,
		DealerVenueToolsComponent,
		DeviceManagementComponent,
		DevicesComponent,
		EGiftCardDenominationSetupComponent,
		EGiftCardPoolSetupComponent,
		EGiftEmailSetupComponent,
		EGiftPromoCodeSetupComponent,
		EGiftSetupComponent,
		EGiftTransactionRecordComponent,
		EGiftTransactionsComponent,
		EmployeeLaborShiftComponent,
		EmployeeLaborShiftListComponent,
		EmployeeListComponent,
		EmployeeMessageComponent,
		EmployeeMessageNewRecordComponent,
		EmployeeRecordComponent,
		EmployeeScheduleEventComponent,
		EmployeeScheduleListComponent,
		EmployeeScheduleRecordComponent,
		EmployeeScheduleTimeComponent,
		EmployeeSchedulingComponent,
		EmployeesComponent,
		GeneralDisplaySetupComponent,
		GeneralMessagingSetupComponent,
		GeneralOrderHandlingSetupComponent,
		GeneralPosSetupComponent,
		GeneralSetupComponent,
		GeneralStoreSetupComponent,
		GiftCardAppleWalletSetupComponent,
		GiftCardBalanceSheetComponent,
		GiftCardDashboardComponent,
		GiftCardListComponent,
		GiftCardRecordComponent,
		GiftCardReportsComponent,
		GiftCardSetupComponent,
		GiftCardTransactionsComponent,
		GiftCardViewComponent,
		GroupsComponent,
		GroupSetupComponent,
		GuestViewComponent,
		IntegrationDoordashSetupComponent,
		IntegrationDoordashSetupComponent,
		IntegrationExternalIntegrationSetupComponent,
		IntegrationExternalIntegrationSetupComponent,
		IntegrationSetupComponent,
		IntegrationThirdPartyIntegrationSetupComponent,
		IntegrationThirdPartyIntegrationSetupComponent,
		IntegrationUbereatsRequestListComponent,
		IntegrationUbereatsSetupComponent,
		IntegrationUbereatsSetupComponent,
		InternetHistoryReportComponent,
		InvoiceDashboardComponent,
		InvoiceListComponent,
		InvoiceRecordComponent,
		InvoiceRecordLinesComponent,
		ItemDashComponent,
		ItemPerformanceViewComponent,
		ItemTagSetupComponent,
		KitchenDeviceColorProfileSetupComponent,
		KitchenDeviceFeatureSetupComponent,
		KitchenDeviceListComponent,
		KitchenDeviceSetupComponent,
		KitchenOrderReadySmsMessageComponent,
		KitchenOrderTypeSetupComponent,
		KitchenPerformanceDashboardComponent,
		KitchenPrintOrderRecordComponent,
		KitchenPrintOrdersComponent,
		KitchenSetupComponent,
		LaborDashComponent,
		LinkKeySetupComponent,
		LinkQrExportComponent,
		LogCommentComponent,
		LogCommentCreateComponent,
		LoginComponent,
		LogListViewComponent,
		LogViewerComponent,
		LogViewSalesSummaryComponent,
		LoyaltyComponent,
		LoyaltyEmailTemplateSetupComponent,
		MenuItemCanvasViewComponent,
		MenuItemDetailComponent,
		MenuItemModifierViewComponent,
		MenuItemNutritionalInformationComponent,
		MenuItemPriceRecordComponent,
		MenuItemRecordSetupComponent,
		MenuItemSetupComponent,
		MenuItemSubscriptionHistoryComponent,
		MenuItemSubscriptionSetupComponent,
		MenuSetupComponent,
		MobilePaySetupComponent,
		OnDeviceFeaturesComponent,
		OnDeviceListComponent,
		OnDevicePaymentComponent,
		OnDeviceSettingsComponent,
		OnDeviceSetupComponent,
		OnLicenseModesComponent,
		OnlineDashComponent,
		OnSetupComponent,
		OoMenuExternalLinkComponent,
		OrderTypeAtTableSettingsComponent,
		OrderTypeCustomFieldsComponent,
		OrderTypeKioskSetupComponent,
		OrderTypeMealPeriodWidgetComponent,
		OrderTypeRecordSetupComponent,
		OrderTypeSettingsComponent,
		OrderTypeSetupComponent,
		OrderTypeThrottlingComponent,
		OrderTypeTipsComponent,
		OrderTypeZonesComponent,
		PaymentLoyaltySetupComponent,
		PaymentProcessorFocuspayDatacapComponent,
		PaymentProcessorSetupComponent,
		PriceLevelSetupComponent,
		PrinterDeviceListComponent,
		PrinterDeviceSetupComponent,
		ProcessingStatusComponent,
		ProductBubbleChartComponent,
		ProductDashboardComponent,
		ProductSectionComponent,
		ProductUseDashboardComponent,
		ProductUseReportComponent,
		PromoCodeListViewComponent,
		PromoCodeRecordViewComponent,
		PromoCodeSetupComponent,
		RegisterDealComponent,
		ReportFutureOrderItemComponent,
		ReportsCategoriesComponent,
		ReportsComponent,
		ReportSetupComponent,
		ReportsHeaderComponent,
		SalesDashComponent,
		SalesGuestWidgetComponent,
		ServiceSubscriptionDashboardComponent,
		ServiceSubscriptionListComponent,
		ServiceSubscriptionRecordComponent,
		SnapshotSetupComponent,
		SocketMessageComponent,
		SocketMonitorComponent,
		StyleSetupComponent,
		SubscriptionDashboardViewComponent,
		SubscriptionListComponent,
		SubscriptionRecordViewComponent,
		SubscriptionSetupComponent,
		SystemStatusDashboardComponent,
		TableDataModelListComponent,
		TableDataModelSetupComponent,
		TablePerformanceReportComponent,
		TemplatesComponent,
		TemplateSetupComponent,
		TimeAndAttendanceComponent,
		TimecardListComponent,
		TimecardRecordComponent,
		TimeRangesComponent,
		TimeRangeSetupComponent,
		TipPoolReportComponent,
		TipPoolSetupComponent,
		UserClaimComponent,
		UserDetailComponent,
		UserMenuSetupComponent,
		UserPasswordResetComponent,
		UserProfileComponent,
		UserSetupComponent,
		UserVenueSetupComponent,
		VenueAdministrationComponent,
		VenueGroupSetupComponent,
		VenueIntegrationsComponent,
		VenueLicensesComponent,
		VenueSetupComponent,
		WebhookRecordComponent,
		WebhookSetupComponent,
  EmployeeSchedulingSetupComponent,
  EmployeeLaborShiftRecordComponent,
  EmployeeSchedulingSetupJobRuleComponent,
  EmployeeSchedulingSetupGlobalRulesComponent,
	],
	imports: [SharedModule, FocuspayModule, CommandCenterRoutingModule],
})
export class CommandCenterModule {}
